import api from './api';

export const getBulkOps = async () => {
  const { data } = await api.get('/bulk-ops');
  return data;
};

export const createBulkOp = async (params) => {
  const { data } = await api.post('/bulk-ops', params);
  return data;
};

export const updateBulkOp = async (id, params) => {
  const { data } = await api.put(`/bulk-ops/${id}`, params);
  return data;
};

export const deleteBulkOp = async (id) => {
  const { data } = await api.delete(`/bulk-ops/${id}`);
  return data;
};

export const runBulkOp = async (id) => {
  const { data } = await api.post(`/bulk-ops/${id}/run`);
  return data;
};
